import { render, staticRenderFns } from "./relationsNetwork.vue?vue&type=template&id=c6940e2a&scoped=true&"
import script from "./relationsNetwork.vue?vue&type=script&lang=js&"
export * from "./relationsNetwork.vue?vue&type=script&lang=js&"
import style0 from "./relationsNetwork.vue?vue&type=style&index=0&id=c6940e2a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6940e2a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/corp-dev.1clicom.ru/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c6940e2a')) {
      api.createRecord('c6940e2a', component.options)
    } else {
      api.reload('c6940e2a', component.options)
    }
    module.hot.accept("./relationsNetwork.vue?vue&type=template&id=c6940e2a&scoped=true&", function () {
      api.rerender('c6940e2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/ui/relationsNetwork/relationsNetwork.vue"
export default component.exports